import { useGetGroupStatus } from '@/domain/groups/hooks';
import { StatusNotification } from './StatusNotification';

export default function StatusAlert() {
  const { data, isLoading } = useGetGroupStatus();
  if (!isLoading && data?.status !== 'success') {
    return <StatusNotification status={data?.status} groupName={data?.groupName} />;
  }
}
